/** Shared frosted chrome for model-viewer control pills (scheme-aware). */
export const VIEWER_CONTROL_CHROME_STYLE = {
  backgroundColor: 'color-mix(in srgb, var(--mantine-color-body) 92%, transparent)',
  backdropFilter: 'blur(10px)',
  border: '1px solid var(--mantine-color-default-border)',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
  color: 'var(--mantine-color-text)',
} as const;

export const VIEWER_CONTROL_CHROME_HOVER_BG = 'var(--mantine-color-body)';
